<template>
  <div class="review-card">
    <v-row no-gutters>
      <v-col cols="8" class="px-0 py-0">
        <div class="review-details">
          <h4 class="review-title">Автор: {{ review.client_name }}</h4>
          <p
            style="
              margin-top: 10px;
              margin-bottom: 0px;
              text-overflow: ellipsis;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 10;
              -webkit-box-orient: vertical;
              word-break: break-word;
              white-space: normal;
              max-height: 4.2em;
            "
          >
            <span style="font-weight: 600">Текст відгуку:</span>
            {{ review.text }}
          </p>
        </div>
      </v-col>
      <v-row no-gutters justify="end">
        <admin-submit-button
          @click="$emit('setItemForEdit', review)"
          height="38px"
        >
          <v-icon color="#FFFFFF" style="margin-right: 4px"
            >mdi-pencil-outline</v-icon
          >
          Редагувати</admin-submit-button
        >
        <admin-submit-button
          @click="showConfirmDeleteModal = true"
          style="background: #d32f2f; margin-left: 10px"
        >
          <v-icon color="#FFFFFF" style="margin-right: 4px"
            >mdi-delete-outline</v-icon
          >
          Видалити</admin-submit-button
        >
      </v-row>
    </v-row>
    <confirm-delete-modal
      v-if="showConfirmDeleteModal"
      :visible="showConfirmDeleteModal"
      title="Видалити відгук"
      text="Ви впевнені, що хочете видалити цей відгук? Цю дію не можна скасувати."
      @close="showConfirmDeleteModal = false"
      @confirm="
        $emit('deleteReview', review.id), (showConfirmDeleteModal = false)
      "
    />
  </div>
</template>

<script>
import AdminSubmitButton from "../../UI/Btns/adminSubmitButton.vue";
import ConfirmDeleteModal from "../../UI/Modals/confirmDeleteModal.vue";

export default {
  components: {
    AdminSubmitButton,
    ConfirmDeleteModal,
  },
  data: () => ({
    showConfirmDeleteModal: false,
  }),
  props: {
    review: {
      required: true,
    },
  },
};
</script>

<style scoped>
.review-card {
  padding: 15px 10px;
  color: #1d1d1d;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  border-radius: 10px;
  border: 1px solid #e7e7e7;
  background: #fff;
  display: flex;
  margin-bottom: 15px;
}
.review-title {
  color: #1d1d1d;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
}
.review-details {
  margin-left: 10px;
}
</style>